import { DesktopRestAPI } from '~/api/core'

const processStepsAPI = new DesktopRestAPI('/api/process-steps')

export default processStepsAPI
